export default __webpack_public_path__ + "static/media/letter-spacing-filled.26982231.svg";